module.exports = __webpack_public_path__ + "img/breathing-bad.3f6f4d0a.svg";